var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { StringMatchService } from '@/domains/utils/types/string-match-service.interface';
import { ROOT_FOLDER_ID } from '../constants';
let FolderTreeServiceImpl = class FolderTreeServiceImpl {
    constructor(_stringMatchService) {
        this._stringMatchService = _stringMatchService;
    }
    filterFolderList(folderList, keyword) {
        // 如果关键词为空，返回原始树
        if (!keyword) {
            return folderList;
        }
        const filteredFolderList = [];
        for (const folder of folderList) {
            // 递归过滤子节点
            const filteredChildren = folder.children ? this.filterFolderList(folder.children, keyword) : [];
            // 如果节点名称包含关键词，或者有子节点包含关键词，则保留该节点
            if (this._stringMatchService.match(folder.folder_name, keyword) || filteredChildren.length > 0) {
                filteredFolderList.push({
                    ...folder,
                    folder_label: this._stringMatchService.highlight(folder.folder_name, keyword),
                    children: filteredChildren,
                });
            }
        }
        return filteredFolderList;
    }
    getFolderFromFolderList(folderList, folderId) {
        for (const folder of folderList) {
            if (folder.folder_id === folderId) {
                return folder;
            }
            if (folder.children) {
                const childFolder = this.getFolderFromFolderList(folder.children, folderId);
                if (childFolder) {
                    return childFolder;
                }
            }
        }
        return null;
    }
    getChildrenByParentId(folderList, parentFolderId) {
        if (parentFolderId === ROOT_FOLDER_ID) {
            return folderList;
        }
        const parentFolder = this.getFolderFromFolderList(folderList, parentFolderId);
        return parentFolder ? parentFolder.children : [];
    }
    deleteFolder(folderList, folderId) {
        const _deleteFolder = (folderId, folderList) => {
            for (let i = 0; i < folderList.length; i++) {
                if (folderList[i].folder_id === folderId) {
                    folderList.splice(i, 1);
                }
                else {
                    _deleteFolder(folderId, folderList[i].children);
                }
            }
        };
        _deleteFolder(folderId, folderList);
    }
    flattenFolderList(folderList) {
        return folderList.flatMap(folder => folder.children?.length ? [folder, ...this.flattenFolderList(folder.children)] : [folder]);
    }
};
FolderTreeServiceImpl = __decorate([
    injectable(),
    __param(0, inject(StringMatchService)),
    __metadata("design:paramtypes", [typeof (_a = typeof StringMatchService !== "undefined" && StringMatchService) === "function" ? _a : Object])
], FolderTreeServiceImpl);
export { FolderTreeServiceImpl };
